/*eslint-disable no-undef*/
import { connect } from 'react-redux'
import * as Jsx from './index.jsx'

const RxComponent = global.rootRequire('components/shares/rxComponent').default

const { rxaget, changeTheme, changeTheme_ThemeColor, loadIconUrl } = global.rootRequire('classes/ulti')
const themeData = global.rootRequire('classes/themeData.json')
const theme_themeColorData = global.rootRequire('classes/theme_themeColorData.json')
const { rxgetLocal, rxsetLocal } = global.rootRequire('classes/request')
const stickerData = global.rootRequire('classes/stickerData.json');
const rxio = global.rootRequire('classes/socket').default
const { netalogoutAction, setComp, saveNotificationStatus } = global.rootRequire('redux')
const chatDB = global.rootRequire('classes/indexedDB').default

class ChatComponent_ extends RxComponent {
  constructor(props, context) {
    super(props, context, Jsx)
    this.state = {
      contacts: {},
      listCallLog: [],
      flagCalling: 0,
      objsCalling: {},
      reloadPage: false,
      groups: {},
      displayAddContact: false,
      flagEdit: false,
      flagCalendar: false,
      flagBlockFooter: false,
      flagMenu: false,
      contactInfo: {}
    }

    this.userid = rxaget(this.props, 'netaauth.user.id', '')
    this.token = rxaget(this.props, 'netaauth.user.token', '')

    this.onSubmitContact = this.onSubmitContact.bind(this)
    this.closeCalendar = this.closeCalendar.bind(this)
  }

  componentDidMount() {
    const color = global.rxu.json(rxgetLocal('netaThemeColor'), '')
    const themeBackGround = global.rxu.json(rxgetLocal('netaThemeBackGround'), '')
    const notificationStatusValueTmp = rxgetLocal('netaNotificationStatus')


    if (!window.Notification) {
      console.log('Browser does not support notifications.');
    } else {
      if (Notification && Notification.permission === "denied") {
        this.props.saveNotificationStatus(JSON.stringify(false))
      } else {
        if (typeof (notificationStatusValueTmp) === 'undefined') {
          this.props.saveNotificationStatus(JSON.stringify(true))
        }
      }
    }


    loadIconUrl()
    if (themeBackGround === 'darkTheme') {
      changeTheme(themeData.nightTheme)
      changeTheme_ThemeColor(theme_themeColorData.nightTheme)
    } else {
      changeTheme(themeData.defaultTheme)
      if (color === 'blueColor') {
        changeTheme_ThemeColor(theme_themeColorData.blueColor)
      } else {
        changeTheme_ThemeColor(theme_themeColorData.orangeColor)
      }
    }

    const rxSticker = global.rxu.json(rxgetLocal('rxsticker'), {})
    if (!rxSticker.version || (rxSticker.version && (Number(rxSticker.version) < Number(stickerData.version)))) {
      rxsetLocal('rxsticker', JSON.stringify(stickerData))
    }

    if (window && window.ipcRenderer) {
      window.ipcRenderer.on('new_sticker', (event, args) => {
        if (args) {
          try {
            let objSticker = JSON.parse(args)
            if (objSticker.version) {
              rxsetLocal('rxsticker', args)
            }
          } catch (e) {
          }
        }
      })
    }

    rxio.getWaitExpired(() => {
      try {
        if (rxio.connected) {
          rxio.disconnect()
        }

        this.props.netalogoutAction()
        this.props.setComp('login')

        chatDB.close()
        chatDB.delete().then(() => {
          console.log("Database successfully deleted")
          chatDB.open()
        }).catch((err) => {
          chatDB.open()
          console.error("Could not delete database")
        })

      } catch (e) { }
    })

    this.intervalId = setInterval(this.timer.bind(this), 60000);
  }

  componentWillUnmount() {
    clearInterval(this.intervalId)
  }

  onClickAddFriend = () => {
    let modalAddFriend = this.state.modalAddFriend
    this.setState({ modalAddFriend: !modalAddFriend })
  }

  callBackRedirectParent() {
    // this.props.history.push('/chat')
    this.props.setComp('chat')
  }

  checkClickOutside(e) {

    const menuDiv = document.getElementById('menu-message')
    const menuDiv2 = document.getElementById('menu-mouseright-chat')
    const menuDivGroup = document.getElementById('context_menu-group')
    const menuDivMenu = document.getElementById('tab-menu-mess')
    // const groupPopup = document.getElementById('popup-group')
    if (menuDiv && e.target !== menuDiv && menuDiv.style.display === 'block') {
      menuDiv.style.display = 'none'
      this.setState({ mess_selected: {}, mess_id: '' })
    }
    if (menuDivGroup && e.target !== menuDivGroup && menuDivGroup.style.display === 'block' && e.target.className.indexOf('chatfolder') === -1) {
      menuDivGroup.style.display = 'none'
      this.setState({ mess_selected: {}, mess_id: '' })
    }
    if (menuDiv2 && e.target !== menuDiv2 && menuDiv2.style.display === 'block') {
      menuDiv2.style.display = 'none'
      this.setState({ mess_selected: {}, mess_id: '' })
    }
    if (menuDivMenu && ['tab-option-mess-row', 'tab-menu-mess-box', 'tab-option-mess-row'].indexOf(e.target.className) === -1) {
      menuDivMenu.style.display = 'none'
    }
  }

  onClickAddContact(ele) {
    let contactInfo = { Username: ele.login, Fullname: ele.full_name }
    this.setState({ displayAddContact: true, contactInfo: contactInfo })
  }

  onClickShowCalendar() {
    let flagCalendar = this.state.flagCalendar
    this.setState({ flagCalendar: !flagCalendar })
  }

  closeCalendar() {
    this.setState({ flagCalendar: false })
  }

  onSubmitContact(addContactValue) {
    let address_book_link = global.rxu.config.base_api_neta + '/api/address_book/create'
    let arrContacts = addContactValue
    let params = { "Fullname": arrContacts.Fullname, "Username": arrContacts.Username }
    let headers = { 'Accept': 'application/json', 'Content-Type': 'application/json; charset=utf-8', 'TC-Token': this.token }
    fetch(address_book_link, {
      method: 'POST',
      body: JSON.stringify(params),
      headers: headers
    }).then((res) => { return res.json() })
      .then((json) => {
        try {
          // let that = this
          // fetchContact({ netaContact: rxaget(that.props, 'netaContact.data', {}), token: that.token }, (newContacts) => {
          //   that.props.contactAdd(newContacts)

          //   this.fetchData()
          // })
          this.setState({
            displayAddContact: false,
            flagEdit: false,
            contactInfo: {}
          })
        } catch (error) { console.log(error) }

      }).catch(er => console.log(er))
  }

  timer() {
    // fetch(global.rxu.config.base_api_neta + '/api/session.json', {
    //   method: 'GET',
    //   headers: { 'TC-Token': this.token, 'Accept': 'application/json', 'Content-Type': 'application/json; charset=utf-8' }
    // }).then(r => r.json()).then((json) => {
    //   if (json && json.Code === 401 && json.Message === "Unauthorized") {
    //     try {
    //       if (rxio.connected) {
    //         rxio.disconnect()
    //       }
    //       this.props.netalogoutAction()
    //       this.props.setComp('login')

    //       if (this.intervalId) {
    //         clearInterval(this.intervalId)
    //       }

    //     } catch(e) {}
    //   }
    // })
  }

  blockFooterFunc() {
    this.setState({
      flagBlockFooter: true
    })
  }

  showFooterFunc() {
    this.setState({
      flagBlockFooter: false
    })
  }

  toggleMenu() {
    this.setState({ flagMenu: !this.state.flagMenu })
  }

  render() {
    console.log('Render Main')
    return this.renderComponent()
  }
}

const mapStateToProps = (state, ownProps) => ({
  themeValue: state.themeValue,
  netaauth: state.netaauth,
  activeComponent: state.activeComponent
})

const mapDispatchToProps = {
  netalogoutAction, setComp,
  saveNotificationStatus
}

const ComponentWrapped = connect(
  mapStateToProps,
  mapDispatchToProps
)(ChatComponent_)

export default ComponentWrapped
